var m = require('mithril');
var ResizeObserver = require('resize-observer-polyfill').default;
var createObserver = require('../utils/observer').default;
var { observe, unobserve } = createObserver(ResizeObserver);

module.exports = {

    width: null,
    visible: false,

    oncreate: ({ state, dom }) => {
        state.onResize = () => {
            state.width = dom.getBoundingClientRect().width;
            m.redraw();
        }
        observe(dom, state.onResize)
    },

    onremove: ({ dom, state }) => {
        unobserve(dom, state.onResize);
    },

    view: ({
        attrs: { inline, srcs, style = {}, alt },
        state: { width }
    }) => {
        var { w, h } = srcs[0];
        var className = [
            'image',
            inline && 'image_inline',
        ].filter(x => x).join(' ');
        style = Object.assign({
            width: '100%',
            height: '100%',
            paddingBottom: inline ? h / w * 100 + '%' : 0,
        }, style);
        return m('div', { className, style },
            m('img.image__image', {
                alt,
                src: width
                    ? srcs[srcs.length - 1].url
                    : undefined,
                srcset: width
                    ? srcs.map(({ url, w }) => `${url} ${w}w`).join(', ')
                    : undefined,
                sizes: width
                    ? `${width}px`
                    : undefined
            })
        )
    }
}

// var DPR = window.devicePixelRatio || 1;

// var update = ({ attrs: { srcs }, dom, state }) => {

//     var { top, bottom, width } = dom.getBoundingClientRect();

//     var visible = bottom > 0 && top < window.innerHeight;

//     if ( !visible ) return;

//     var src = selectSrc( srcs, width );

//     if ( state.src !== src ) {

//         state.loading = true;
//         state.src = src;

//         loadImage( src.url ).then( () => {
//             state.loading = false;
//             m.redraw();
//         });

//     }

// }

// module.exports = {

//     src: null,

//     visible: false,

//     loading: true,

//     oncreate: update,

//     onupdate: update,

//     view: ({
//         attrs: { inline, srcs, style = {} /*, cover, width = '100%', height = '100%' */ },
//         state: { src, loading },
//     }) => {

//         var { w, h } = srcs[ 0 ];

//         var className = [
//             'image',
//             inline && 'image_inline',
//             !loading && 'image_loaded'
//         ].filter( x => x ).join(' ');

//         style = Object.assign({
//             width: '100%',
//             height: '100%',
//             backgroundImage: src ? `url(${ src.url })` : 'none',
//             backgroundSize: 'cover',
//             paddingBottom: inline ? h / w * 100 + '%' : 0,
//         }, style );

//         return m( 'div', { className, style } );

//     }

// }


// WEBPACK FOOTER //
// ./js/components/Image.js